import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EmployeeCourseFilterInput } from "../../core/interfaces/employee-course-input";

@Injectable()
export class SStatsCardEmployeeCourseService {

    private readonly endpointQuery = "hcm/analytics_sst/queries";

    constructor(private readonly httpClient: HttpClient) {}

    totalizerEmployeeCourseCardsCount(filter: EmployeeCourseFilterInput) {
        return this.httpClient.post(`${this.endpointQuery}/employeeCourseTotalizerQuery`, {
            ...filter
        });
    }
}
